import { Link } from "react-router-dom";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageKidE.module.scss";

function PageKidE() {
  const getImgSet = useImgSet();

  const content = getImgSet("content__p07", "png", s.content);

  const back = getImgSet("back__p22", "png");

  return (
    <div className={s.root}>
      <div className={s.inner}>
        {content}
        <Link to="/kid/d" className={s.back}>
          {back}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutSimple(PageKidE, false, false, false);
